import React, { useState, useEffect } from 'react'
import {
    Grid, Box, TextField, Button, FormControlLabel, Checkbox, IconButton, useMediaQuery,
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextareaAutosize,
    Typography, Divider, Table, TableBody, TableCell, TableContainer, TableHead,
    TableRow, Paper, List, ListItem, ListItemText
} from '@mui/material';
//import ConsumptionRatio from '../../Dashboard/ConsumptionRatio';
import { useSelector, useDispatch } from "react-redux";
import { setState, updateWeeklyData } from '../reviewSlice';
import _ from "lodash";
import { CatchingPokemonSharp, TypeSpecimenRounded, Undo } from '@mui/icons-material';
import { createActionCreatorInvariantMiddleware } from '@reduxjs/toolkit';

const RowModification = (props) => {
    const dispatch = useDispatch();
    const review = useSelector((state) => state.review);
    const {
        ModifiedList,getWeekStatus
    } = review;
    const params = props.params;
    const type = props.type;
    const getUpdatedRowIds = props.getUpdatedRowIds;
    const selectedValues = props.selectedValues;
    const displayNewFinalQuota = selectedValues.includes("New Final Quota");
    const displayDeltaModifications = selectedValues.includes("Delta Modifications");
    const displayLastApprovedMod = selectedValues.includes("Last Approved Modification");
    const displayInitialQuota = selectedValues.includes("Initial Quota");
    const weeklyPullForward = props.weeklyPullForward;
    const rowSelectionModel = props.rowSelectionModel;
    const isCheckedHeader = props.isCheckedHeader;
    const modificationPercentage = props.modificationPercentage;
    const modPercFunc = props.modPercFunc;
    const rounderFunc = props.rounderFunc;
    const rounder = props.rounder;
    const updatedWeeklyData = props.updatedWeeklyData;
    const currentWeek = props.currentWeek;
    const biweeklyHalf = props.biweeklyHalf ?? 0;
    let weekNumber = parseInt(type.replace(/\D/g, ''), 10);
    const idx = updatedWeeklyData.findIndex((customer) => customer.customerQuotaID === params.row.customerQuotaID);
    const rowDepletionModel = (
      updatedWeeklyData[idx]?.depletionModel ??
      ""
    )
      .trim()
      .toLowerCase();

    const isFourWeekPeriod = (
      ModifiedList?.depletionPeriodType ?? ModifiedList?.DepletionPeriodType ?? ""
    )
      .trim()
      .toLowerCase()
      .includes("4-week");

    const isWeekInactiveForDepletionModel =
      (rowDepletionModel === "none" && weekNumber >= 2) ||
      (rowDepletionModel === "biweekly" && weekNumber >= 3);

    const activeWeekForRow =
      rowDepletionModel === "none"
        ? 0
        : rowDepletionModel === "biweekly"
          ? biweeklyHalf
          : currentWeek;

    const isFieldDisabled =
      isWeekInactiveForDepletionModel ||
      (rowDepletionModel === "biweekly" &&
        biweeklyHalf > 0 &&
        weekNumber < biweeklyHalf) ||
      (rowDepletionModel !== "none" &&
        rowDepletionModel !== "biweekly" &&
        weekNumber < currentWeek);

    const removeComma = (str) => {
      let formattedString = "";
      for (let i = 0; i < str.length; i++) {
        if (str[i] !== ",") {
          formattedString += str[i];
        }
      }
      return formattedString;
    };

    const formatDisplayValue = (value) => {
      if (isWeekInactiveForDepletionModel) return "";
      if (value === "" || value == null) return "";
      const num = Number(value);
      if (!Number.isFinite(num)) return "";
      return num.toLocaleString("en-US");
    };

    const formatDeltaDisplayValue = (value) => {
      if (isWeekInactiveForDepletionModel) return "";
      if (value === "" || value == null) return "";
      if (value === "-") return "-";
      const normalized = removeComma(String(value));
      if (normalized === "-") return "-";
      const num = Number(normalized);
      if (Number.isFinite(num)) return num.toLocaleString("en-US");
      if (/^-?\d+$/.test(normalized)) return normalized;
      return "";
    };

    const [newFinalQuota, setNewFinalQuota] = useState(updatedWeeklyData[idx]?.newFinalQuota[`${type}`]);
    const [deltaMod, setdeltaMod] = useState(updatedWeeklyData[idx]?.deltaModification[`${type}`]);

    const [disabled, setDisabled] = useState(false);
    const [values, setValues] = useState({
        weekly1: '',
        weekly2: '',
        weekly3: '',
        weekly4: '',
        weekly5: '',
    });

    const style = {
        p: 0,
        width: '100%',
        maxWidth: 350,
        fontSize: '10px',
        //borderRadius: 2,
        //border: '1px solid black',
        //borderColor: 'divider',
        textAlign: 'center'
        //backgroundColor: 'background.paper',
    };
    useEffect(() => {
      if (idx <= -1) return;
      if (
        newFinalQuota !== updatedWeeklyData[idx]?.newFinalQuota[`${type}`] ||
        deltaMod !== updatedWeeklyData[idx]?.deltaModification[`${type}`]
      ) {
        setNewFinalQuota(updatedWeeklyData[idx]?.newFinalQuota[`${type}`]);
        setdeltaMod(updatedWeeklyData[idx]?.deltaModification[`${type}`]);
      }
    }, [
      updatedWeeklyData[idx]?.newFinalQuota[`${type}`],
      updatedWeeklyData[idx]?.deltaModification[`${type}`],
    ]);

    const inactiveListItemSx = {
      minHeight: 40,
      py: 0.5,
    };

    const showMessage = (message, severity) => {
        dispatch(setState("message", message));
        dispatch(setState("severity", severity));
        dispatch(setState("messageOpen", true));
    };
    
    const handleValidity = (customerQuotaID) => {
      setTimeout(() => {
        const i = updatedWeeklyData.findIndex(
          (customer) => customer.customerQuotaID === customerQuotaID
        );
        if (i <= -1) return;

        const row = updatedWeeklyData[i];
        const q = row.newFinalQuota;
        const consumption = row.consumption;
        const depletionModel = (
          row?.depletionModel ?? ""
        )
          .trim()
          .toLowerCase();

        if (depletionModel === "none") {
          if (q.weekly1 < consumption) {
            showMessage(
              "Quota value should not be less than Consumption value.",
              "error"
            );
          }
          return;
        }

        if (depletionModel === "biweekly") {
          if (q.weekly1 > q.weekly2) {
            showMessage(
              "Quota value for weeks ahead of Week 1 should be greater than Week 1 value.",
              "error"
            );
            return;
          }
          if (
            q.weekly2 < consumption ||
            (getWeekStatus.chkFirstHalf && q.weekly1 < consumption)
          ) {
            showMessage(
              "Quota value should not be less than Consumption value.",
              "error"
            );
          }
          return;
        }

        if (getWeekStatus.chkWeek1) {
          const week1OrderInvalid = isFourWeekPeriod
            ? q.weekly2 < q.weekly1 ||
              q.weekly3 < q.weekly1 ||
              q.weekly4 < q.weekly1
            : q.weekly2 < q.weekly1 ||
              q.weekly3 < q.weekly1 ||
              q.weekly4 < q.weekly1 ||
              q.weekly5 < q.weekly1;
          if (week1OrderInvalid) {
            showMessage(
              "Quota value for weeks ahead of Week 1 should be greater than Week 1 value.",
              "error"
            );
            return;
          }
        }
        if (getWeekStatus.chkWeek2) {
          const week2OrderInvalid = isFourWeekPeriod
            ? q.weekly3 < q.weekly2 || q.weekly4 < q.weekly2
            : q.weekly3 < q.weekly2 ||
              q.weekly4 < q.weekly2 ||
              q.weekly5 < q.weekly2;
          if (week2OrderInvalid) {
            showMessage(
              "Quota value for weeks ahead of Week 2 should be greater than Week 2 value.",
              "error"
            );
            return;
          }
        }
        if (getWeekStatus.chkWeek3) {
          const week3OrderInvalid = isFourWeekPeriod
            ? q.weekly4 < q.weekly3
            : q.weekly4 < q.weekly3 || q.weekly5 < q.weekly3;
          if (week3OrderInvalid) {
            showMessage(
              "Quota value for weeks ahead of Week 3 should be greater than Week 3 value.",
              "error"
            );
            return;
          }
        }
        if (
          getWeekStatus.chkWeek4 &&
          !isFourWeekPeriod &&
          q.weekly5 < q.weekly4
        ) {
          showMessage(
            "Week 5 Quota should be greater than previous Week Quota.",
            "error"
          );
          return;
        }

        const consumptionInvalid = isFourWeekPeriod
          ? (getWeekStatus.chkWeek1 && q.weekly1 < consumption) ||
            (getWeekStatus.chkWeek2 && q.weekly2 < consumption) ||
            (getWeekStatus.chkWeek3 && q.weekly3 < consumption) ||
            (getWeekStatus.chkWeek4 && q.weekly4 < consumption)
          : q.weekly5 < consumption ||
            (getWeekStatus.chkWeek4 && q.weekly4 < consumption) ||
            (getWeekStatus.chkWeek3 && q.weekly3 < consumption) ||
            (getWeekStatus.chkWeek2 && q.weekly2 < consumption) ||
            (getWeekStatus.chkWeek1 && q.weekly1 < consumption);

        if (consumptionInvalid) {
          showMessage(
            "Quota value should not be less than Consumption value.",
            "error"
          );
        }
      }, 500);
    };
    const handleNewQuotaChange = (e) => {
        let value = 0;
        if(e.target.value === ""){
            value = 0
        }
        else{
            value = Number(removeComma(e.target.value));
        }
        if (!isNaN(value)) {
        // The new value entered by the user
          setNewFinalQuota(value);
          
          //const updatedState = _.cloneDeep(updatedWeeklyData);
          //const customerToUpdate = updatedWeeklyData.find((customer) => customer.customerQuotaID === params.row.customerQuotaID);
          const deltaModificationVal = parseInt(value) - parseInt(params.row.lastApproved[`${e.target.name}`]);
          setdeltaMod(deltaModificationVal);
          //setUpdatedRow((prev) => ({ ...updatedRow, rowInfo2: { ...updatedRow.rowInfo2, [e.target.name]: deltaModificationVal } }))

          // const { name, value } = e.target;
          // const newValues = { ...values, [name]: Number(value) };
          //setValues(newValues);
          // setErrors1(validateNewQuotaFields(Object.values(newValues), params.id));

          //const newErrors = validateNewQuotaFields(Object.values(newValues));

          // Update the errors state only if there are changes
          // if (JSON.stringify(errors1) !== JSON.stringify(newErrors)) {
          //     setErrors1(newErrors);
          // }
          // const { name, value } = e.target;
  
          // validateNewQuotaFields(newWeeklyValues, params.id);
          // return { ...row, newFinalQuota: newWeeklyValues };


          const payload = {
              customerQuotaID: params.row.customerQuotaID, // Specify the customer ID
              key1: e.target.name, // Property to update (e.g., 'weekly1')
              value1: parseInt(value), // New value
              key2: e.target.name, // Property to update (e.g., 'weekly1')
              value2: deltaModificationVal // New value
          };
          dispatch(updateWeeklyData(payload));
          // if (customerToUpdate && _.has(customerToUpdate, payload.key1) && _.has(customerToUpdate, payload.key2)) {
          //     _.set(customerToUpdate, payload.key1, payload.value1);
          //     _.set(customerToUpdate, payload.key2, payload.value2);
          // }

          props.getUpdatedRowIds(params.row.customerQuotaID);
          if(e.target.name === 'weekly'+ activeWeekForRow){
              dispatch(setState("isCurrentWeekRowChanged", true));
          }
        }else{
          showMessage("Only numbers are allowed in the New Final Quota field. Please enter a valid number", "error");
        }
    };

    const applyDeltaModification = (weekKey, deltaValue) => {
      const lastApproved = Number(params.row.lastApproved[weekKey]) || 0;
      const newQuotaVal = deltaValue + lastApproved;
      setdeltaMod(deltaValue);
      setNewFinalQuota(newQuotaVal);
      dispatch(
        updateWeeklyData({
          customerQuotaID: params.row.customerQuotaID,
          key1: weekKey,
          value1: newQuotaVal,
          key2: weekKey,
          value2: deltaValue,
        })
      );
      props.getUpdatedRowIds(params.row.customerQuotaID);
      if (weekKey === `weekly${activeWeekForRow}`) {
        dispatch(setState("isCurrentWeekRowChanged", true));
      }
    };

    const handleDeltaChange = (e) => {
      const weekKey = e.target.name;
      let raw = removeComma(e.target.value);
      if (raw === "0-") {
        raw = "-";
      }

      if (raw === "") {
        applyDeltaModification(weekKey, 0);
        return;
      }

      if (raw === "-") {
        setdeltaMod("-");
        return;
      }

      const deltaValue = Number(raw);
      if (!Number.isNaN(deltaValue)) {
        applyDeltaModification(weekKey, deltaValue);
        return;
      }

      showMessage(
        "Only numbers are allowed in the Delta Modification field. Please enter a valid number.",
        "error"
      );
    };

    const handleDeltaBlur = () => {
      if (deltaMod === "-") {
        applyDeltaModification(type, 0);
      }
      handleValidity(params.row.customerQuotaID);
    };

    return (
        // <List sx={style}>
        //     <div> 
        //         {displayNewFinalQuota && 
        //         <ListItem>
        //             <TextField
        //                 size="small"
        //                 type="text"
        //                 name={`${type}`}
        //                 value={updatedRow?.newFinalQuota[`${type}`]}
        //                 onChange={handleNewQuotaChange}
        //             />
        //         </ListItem>}
        //         <Divider fullWidth component="li" />
        //         {displayDeltaModifications &&
        //         <ListItem>
        //             <TextField
        //                 size="small"
        //                 type="text"
        //                 name={`${type}`}
        //                 value={updatedRow?.deltaModification[`${type}`]}
        //                 onChange={handleDeltaChange}
        //             />
        //         </ListItem>}
        //         <Divider fullWidth component="li" />
        //         {displayLastApprovedMod && 
        //         <ListItem>
        //             <ListItemText primary={updatedRow?.lastApproved[`${type}`]} />
        //         </ListItem>}
        //         {displayInitialQuota &&
        //         <ListItem>
        //             <ListItemText primary={updatedRow?.initialQuota[`${type}`]} />
        //         </ListItem>}

        //     </div>

        // </List>

        <List sx={style}>
            {updatedWeeklyData?.map((row) => {
                return (params.row.customerQuotaID === row.customerQuotaID && <div>
                    {displayNewFinalQuota &&
                        (isWeekInactiveForDepletionModel ? (
                          <ListItem sx={inactiveListItemSx} />
                        ) : (
                        <ListItem>
                            <TextField
                                size="small"
                                type="text"
                                sx={{ width: 105 }}
                                variant="standard"
                                inputProps={{ style: { fontSize: 12, textAlign: 'center' } }}
                                name={`${type}`}
                                disabled={isFieldDisabled}
                                value={formatDisplayValue(newFinalQuota)}
                                onChange={handleNewQuotaChange}
                                onBlur={() => {
                                    handleValidity(params.row.customerQuotaID);
                                }}
                            />
                        </ListItem>
                        ))}
                    {displayDeltaModifications &&
                        (isWeekInactiveForDepletionModel ? (
                          <ListItem sx={inactiveListItemSx} />
                        ) : (
                        <ListItem>
                            <TextField
                                size="small"
                                type="text"
                                sx={{ width: 105 }}
                                variant="standard"
                                inputProps={{ style: { fontSize: 13, textAlign: 'center' } }}
                                disabled={isFieldDisabled}
                                name={`${type}`}
                                value={formatDeltaDisplayValue(deltaMod)}
                                onChange={handleDeltaChange}
                                onBlur={handleDeltaBlur}
                            />
                        </ListItem>
                        ))}
                    {displayLastApprovedMod &&
                        (isWeekInactiveForDepletionModel ? (
                          <ListItem sx={inactiveListItemSx} />
                        ) : (
                        <ListItem>
                            <ListItemText
                                sx={{ textAlign: 'center', paddingRight: '3px' }}
                                primary={formatDisplayValue(row?.lastApproved[`${type}`])}
                                primaryTypographyProps={{ fontSize: 13 }}
                            />
                        </ListItem>
                        ))}
                    {displayInitialQuota &&
                        (isWeekInactiveForDepletionModel ? (
                          <ListItem sx={inactiveListItemSx} />
                        ) : (
                        <ListItem>
                            <ListItemText
                                sx={{ textAlign: 'center', paddingRight: '3px' }}
                                primary={formatDisplayValue(row?.initialQuota[`${type}`])}
                                primaryTypographyProps={{ fontSize: 13 }}
                            />
                        </ListItem>
                        ))}

                </div>
                )
            })
            }

        </List>
    );
}

export default RowModification